import React from 'react';
import Icon from '../ui/AppIcon';
import PWAInstallButton from '../pwa/PWAInstallButton';

const DEVICES = [
  {
    id: 'android',
    title: 'Android',
    icon: 'DevicePhoneMobileIcon',
    badge: 'One-tap install',
    steps: [
      'Open patelsalesonline.com in Chrome',
      'Tap Install App (or Chrome menu → Install app)',
      'Confirm — icon appears on your home screen',
    ],
  },
  {
    id: 'ios',
    title: 'iPhone / iPad',
    icon: 'DevicePhoneMobileIcon',
    badge: 'Safari required',
    steps: [
      'Open the site in Safari (not Chrome / Instagram)',
      'Tap Share (□↑)',
      'Tap Add to Home Screen → Add',
    ],
  },
  {
    id: 'desktop',
    title: 'Windows / Mac',
    icon: 'ComputerDesktopIcon',
    badge: 'Chrome or Edge',
    steps: [
      'Open patelsalesonline.com in Chrome or Edge',
      'Click the install icon in the address bar',
      'Or menu → Install Patel Sales',
    ],
  },
];

export default function DeviceInstallGuides() {
  return (
    <section className="bg-white py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
            Install on every device
          </h2>
          <p className="text-gray-600 text-base leading-relaxed">
            Patel Sales is a Progressive Web App (PWA). You can install it on Android, iPhone, and
            desktop — no App Store or Play Store required.
          </p>
          <div className="mt-6 flex justify-center">
            <PWAInstallButton label="Install on this device" />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-5 sm:gap-6">
          {DEVICES.map((device) => (
            <article
              key={device.id}
              className="rounded-2xl border border-gray-200 bg-[#f8fafc] p-5 sm:p-6 shadow-sm"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-xl bg-[#003087] text-white flex items-center justify-center">
                  <Icon name={device.icon} size={22} />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg">{device.title}</h3>
                  <span className="text-xs font-semibold text-[#e8471e]">{device.badge}</span>
                </div>
              </div>
              <ol className="space-y-2.5">
                {device.steps.map((step, i) => (
                  <li key={step} className="flex gap-2.5 text-sm text-gray-700 leading-relaxed">
                    <span className="font-bold text-[#003087] shrink-0">{i + 1}.</span>
                    <span>{step}</span>
                  </li>
                ))}
              </ol>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
